import React, { useEffect,useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function FormReplaceModal(props) {

    const {replaceModalOpen, onConfirm,onCancel,formCode,matterName} = props;
  return (
    <Dialog
      open={replaceModalOpen}
      // onClose={() => handleClose(false)}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
        {`Form corresponding to the docket ${matterName} and form ${formCode} is already marked as complete. Are you sure you want to replace it?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined" color="primary" >
          No
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus style={{ backgroundColor: '#010160', color: 'white' }}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
